@if (displayType() === 'basket') {
  <div class="quantity-basket-component">
    @if (!showTrashBin || value > min) {
      <div class="quantity-minus" [class.disabled]="disableIncrease || value === min" (click)="handleMinus()">
        @if (useOutline) {
          <mat-icon>remove_circle_outline</mat-icon>
        } @else {
          <mat-icon>remove_circle</mat-icon>
        }
      </div>
    }

    <div class="quantity__number">
      {{ value }}
    </div>

    <div class="quantity-plus" [class.disabled]="disableIncrease || value === max" (click)="handleAdd()">
      @if (useOutline) {
        <mat-icon>add_circle_outline</mat-icon>
      } @else {
        <mat-icon>add_circle</mat-icon>
      }
    </div>
  </div>
}

@if (displayType() === 'upsell') {
  <div class="quantity-upsell">
    @if (!showTrashBin || value > min) {
      <div class="quantity-minus" [class.disabled]="disableIncrease || value === min" (click)="handleMinus()">
        <mat-icon>remove</mat-icon>
      </div>
    }

    <div class="quantity__number">
      {{ value }}
    </div>

    <div class="quantity-plus" [class.disabled]="disableIncrease || value === max" (click)="handleAdd()">
      <mat-icon>add</mat-icon>
    </div>
  </div>
}
